import React, { useState } from 'react';
import AlertComponent from './alert';

const useAlert = () => {
  const [aTitle, setTitle] = useState('');
  const [aMessage, setMessage] = useState('');
  const [showDialog, setShowDialog] = useState(false);

  const showAlertMessage = ({
    title = 'Atenção',
    message
  }) => {
    setTitle(title);
    setMessage(message);
    setShowDialog(true);
  };

  const Alert = () => /*#__PURE__*/React.createElement(React.Fragment, null, showDialog && /*#__PURE__*/React.createElement(AlertComponent, {
    title: aTitle,
    message: aMessage,
    showDialog: showDialog,
    onClickOutside: () => setShowDialog(false),
    width: "300px"
  }));

  return {
    showAlertMessage,
    Alert
  };
};

export default useAlert;